module.exports = __webpack_public_path__ + "static/media/Snapshot Vid Script January 2022_1644338841334.83cbd303.docx";